export const buttonTypes = {
    textButton: 'textButton',
    button: 'button',
    node: 'node',
};
export const SHOW_LABEL = {
    hover: 'hover',
    always: 'always',
};
export const dataHooks = {
    item: 'accordion-item',
    header: 'header',
    toggleButton: 'accordion-toggle-button',
    toggleAccordionWrapper: 'toggle-accordion-wrapper',
    // TODO: mismatch for backwards compat, update when major
    prefix: 'icon',
    suffix: 'suffix',
    subtitle: 'accordion-item-subtitle',
};
export const skins = {
    standard: 'standard',
    light: 'light',
    neutral: 'neutral',
};
export const TITLE_SIZES = {
    small: 'small',
    medium: 'medium',
};
export const SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const horizontalPaddings = {
    none: 'none',
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const contentPaddings = {
    none: 'none',
};
export const transitionSpeeds = {
    slow: 'slow',
    medium: 'medium',
    fast: 'fast',
};
//# sourceMappingURL=constants.js.map